import { render, staticRenderFns } from "./Kirchgemeinden.vue?vue&type=template&id=4fa0b1de&scoped=true&"
import script from "./Kirchgemeinden.vue?vue&type=script&lang=js&"
export * from "./Kirchgemeinden.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa0b1de",
  null
  
)

export default component.exports